module.exports = "/static/js/242d49db42d6cd85ca2b2b78678ae65d.png";